import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    createBreadcrumb,
    getCardPath,
    getCardTitle,
    getDrawPath,
    getImageNameFromdeepLinkType,
    getTheme,
    isMac
} from "@/Utility";
import {APP_WEB, APP_WEB_WWW, DEBUG} from "@/electron_interactive";
import {
    DEFAULT_SLIDER_COMMON_WIDTH,
    DEFAULT_SLIDER_LIBRARY_WIDTH,
    DEFAULT_SLIDER_PDF_WIDTH,
    DEFAULT_SLIDER_WIDTH,
    EVENT_COPY_DOC_NOTE,
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_DELETE_HTML_NOTE,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_FRAME_PAGE_DESC_VISIBLE, EVENT_NOTE_ON_SLIDER_RIGHT, EVENT_OPEN_VIDEO_IN_POPUP,
    EVENT_PDF_ON_SLIDER_RIGHT, EVENT_REFRESH_DEEPLINK_TITLE, EVENT_REFRESH_HIGHLIGHT_LIST,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_SYNC_CARD_DATA_FROM_PAGECARD,
    EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER,
    EVENT_SYNC_JOURNAL_DATA_FROM_PAGEJOURNAL,
    EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER,
    EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,
    EVENT_UPDATE_NOTE, EVENT_VIDEO_ON_SLIDER_RIGHT,
    FROM_LIBRARY, FROM_RIGHT_SIDE, FROM_RIGHT_SIDEBAR, HAS_VIDEO_CAPTURE_TEST, HEADER_HEIGHT, KEY_DEFAULT_PROJECT_ID,
    KEY_FILE_DIR,
    KEY_SELECT_RIGHT_SLIDER_MENU,
    KEY_SLIDER_RIGHT_LIBRARY_WIDTH,
    KEY_SLIDER_RIGHT_WIDTH,
    LASTEST_NOTE_DOC,
    LEFT_MENU_WIDTH,
    MENU_SEPARATOR,
    TITLE_BAR_HEIGHT
} from "@/Const";
import {
    MenuItem,
    generateUUID2,
    getImagePathWithTheme,
    getItem,
    createCopyLink,
    getIntValueFromLocalStrage,
    isStringNullOrEmpty,
    removeHtmlTags,
    getLocalFilePath,
    getFileName,
    getIntValue,
    imgPathPerfix,
    isDarkMode,
    isFileVideoElement,
    isVideo,
    isYoutubeUrl,
    getTimeText,
    formatDate,
    checkIfAbsolute,
    isAudioFileElement,
    isBilibiliUrl,
    isAudio,
    isString,
    createEmptyProject,
    base64ToBlob,
    getFileNameExt,
    isInDraw,
    isInPageCardOrJournal, isAnnoType, isInPageTag, isInPageLibrary, sleep, getImagePathWithThemeSvg, isObject
} from "@/utils";
import {Dropdown, Input, message, Popover, Spin,Tooltip} from "antd";
import Editor from "@/components/EditorV2";
import global from "@/global";
import {
    IconAddToFavor,
    IconAddToProject,
    IconCopyLink,
    IconDelete, IconHomeSearch, IconInfoMenu, IconMakeCopy, IconManagerTags,
    IconMenuExportItem,
    IconOpenInFullscreen,
    IconOpenInPopup, IconRemoveFavor,
    IconRename,
    IconSearch, IconVersionHistory,
    IconViewAllHighlight
} from "@/Icon";
import { t } from "i18next";
import {deleteCard, getCardById, getCardDoc, renameCardById, updateCard} from "@model/card";
import {editDoc} from "@model/doc";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {openEditor} from "@/state";
import {useAtom} from "jotai";
import {atomSliderWidth} from "@/App";
import {hideLoad} from "@/common/loadServer";
import DrawIndexSliderHeader from "@/views/Draw/DrawIndexSliderHeader";
import PageLibrary from "@/views/Library/PageLibrary";
import PageJournal from "@/views/Journal/PageJournal";
import PageHighlight from "@/views/Highlight/PageHighlight";
import DrawIndexBreadcrumb from "@/views/Draw/DrawIndexBreadcrumb";
import {atomHomePaddingLeft, atomIsDragLine, atomSelectSliderRightMenu} from "@/views/Home/HomeIndex";
import VideoLocalContent from "../@excalidraw/packages/excalidraw/components/VideoNotes/VideoLocalContent";
import {isEmbeddableElement} from "../@excalidraw/packages/excalidraw/element/typeChecks";
import VideoContent from "../@excalidraw/packages/excalidraw/components/VideoNotes/VideoContent";
import {videoCache} from "../@excalidraw/packages/excalidraw/components/App";
import {dbGetHighlightByLibraryId} from "@model/highlight";
import SideBarFold, {atomIsSideBarExpand} from "@/components/EditorV2/SideBarFold/SideBarFold";
import HomeIndex from "@/views/Home/views/CanvasListIndex/CanvasListIndex";
import {getNoteById, getNoteJsonDoc} from "@model/note";
import LibraryInfos from "@/views/Library/LibraryInfos";
import {createLibraryItemMenu} from "@/MenuUtils";
import {getLanguageCode} from "@/language";
import ProjectTagFilter from "@/views/Home/ProjectTagFilter";
import ProjectSort from "@/views/Home/ProjectSort";
import {getMarkById} from "@/components/EditorV2/TiptapUtils";
import CustomWebView from "@/views/Webview/CustomWebView";
import {shareCardData} from "@/views/Utils/CardUtils";
import {importTranscriptFromContent} from "@/VideoHighlightUtils";
import {updateTranscript} from "@model/transcript";

let mSliderX = 0;
let mSliderContainerType:any;
let mIsSliderDownPress = false;
let mIsSliderLibraryDownPress = false;
let mIsSliderCommonDownPress = false;
let mMouseMovingTime = 0;
let szOldPdfFileId:any;
let mSearchKey:any;
let mBreadcrumbType:any;

const RightSlider = forwardRef((props, ref)=>{

    useImperativeHandle(ref,()=>({
        onOpenSlider:onOpenSlider,
        onCloseSlider:onCloseSlider
    }))

    const [selectSliderRightMenu,setSelectSliderRightMenu] = useAtom(atomSelectSliderRightMenu);
    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    const [homePaddingLeft, setHomePaddingLeft] = useAtom(atomHomePaddingLeft);
    const [isSidebarExpand] = useAtom(atomIsSideBarExpand);
    const [isDragLine,setIsDragLine] = useAtom(atomIsDragLine);

    const [libraryData,setLibraryData] = useState<any>(null);
    const [title,setTitle] = useState('');
    const [iframePdfContainerPointerEvent, setIframePdfContainerPointerEvent] = useState<string>('all');
    const [sliderHeaderVisible,setSliderHeaderVisible] = useState(true);
    const [arrayBreadcrumb,setArrayBreadcrumb] = useState<any>([]);
    const [editor,setEditor] = useState(null);
    const [libraryContainerPointerEvent,setLibraryContainerPointerEvent] = useState('all');
    const [sideBarStatus, setSideBarStatus] = useState<any>(0);
    const [isSearch,setIsSearch] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const [sliderProjectData,setSliderProjectData] = useState(null);
    const [sliderTitleImage,setSliderTitleImage] = useState<any>(null);
    const [isShowPopupBoard,setIsShowPopupBoard] = useState(false);
    const [sliderTitleInfo,setSliderTitleInfo] = useState<any>(null);
    const [searchPlaceholder,setSearchPlaceholder] = useState<any>('');
    const [selectTag,setSelectTag] = useState(null);
    const [journalData,setJournalData] = useState(null);
    const [isSearching,setIsSearching] = useState(false);

    const divSliderContainerRef = useRef(null);
    const editorRef = useRef(null);
    const iframeRef = useRef(null);
    const pageLibraryRef = useRef(null);
    const pageHighlightRef = useRef(null);
    const videoContentRef = useRef(null);
    const sideBarFoldRef = useRef(null);
    const sideProjectRef = useRef(null);
    const sideInfoRef = useRef(null);
    //只为info使用
    const mDataInfo = useRef(null);
    const projectTagFilterRef = useRef(null);
    const mExtra = useRef<any>(null);
    const mEditorRef = useRef(null);

    /**
     * 打开侧栏
     * @param data
     */
    const onOpenSlider = async (data:any,type:any,extra:any)=>{
        if (window.closeSliderBar){
            //关闭画布页的右侧栏...
            window.closeSliderBar();
        }
        setIsSearch(false);
        setArrayBreadcrumb([]);
        setSearchPlaceholder(t("Search library"));
        mExtra.current = extra;

        const nWidth = getIntValueFromLocalStrage(KEY_SLIDER_RIGHT_WIDTH,DEFAULT_SLIDER_WIDTH);
        setRightSliderWidth(nWidth);
        let szType = 'library';
        if (data){
            if ((data.type == 'card' || data.type == 'journal') && !data.doc){
                const doc = await getCardDoc(data.id);
                data.doc = doc;
            }

            setTitle(data.name || t("Untitled"));
            if (type == 'journal'){
                szType = 'journal'
            }else if (type == 'highlight'){
                szType = 'highlight'
            }
            if (extra){
                if (extra.forceType){
                    szType = extra.forceType;
                    type = szType;
                }
            }

            setArrayBreadcrumb(createBreadcrumb(extra?.breadcrumb || szType,data.name || t("Untitled")));
            // setSelectSliderRightMenu('');
        }else{

        }
        let szSelectSliderRightMenu = localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) || 'library';
        setSelectSliderRightMenu(szSelectSliderRightMenu);
        setSliderHeaderVisible(true);

        setLibraryData(data);

        //后面rename使用
        mBreadcrumbType = extra?.breadcrumb || szType;
        if (extra?.info){
            mDataInfo.current = extra?.info;
        }

        mSliderContainerType = type;
        if (data?.type == 'card'){
            mSliderContainerType = 'card';
        }

        if (szType == 'library' && isVideo(data?.fileName) ||
            isYoutubeUrl(data?.fileName) || isYoutubeUrl(data?.url) ||
            isBilibiliUrl(data?.fileName) || isBilibiliUrl(data?.url) ||
            isAudio(data?.fileName)){
            let highlight = await dbGetHighlightByLibraryId(data.id);
            if (!highlight){
                highlight = {
                    id:data.id,
                    name:data.name,
                    libraryId:data.id,
                    fileName:data.fileName,
                    url:data.url || data.fileName,
                    data:data
                }
            }
            let szElementType = 'embeddable';
            if (data.type == 'video' || data.type == 'audio'){
                szElementType = 'iframe'
            }

            let selectId = extra?.selectedId;
            if (extra?.type == 'transcript'){
                selectId = {type:'transcript',selectId:extra?.selectedId}
            }
            const element = {
                id:highlight.id,
                name:data.name,
                type:szElementType,
                customData:{
                    generationData:{
                        type:'file',
                        id:highlight.libraryId,
                        name:highlight.name,
                        fileName:highlight.fileName
                    }
                },
                selectedId:selectId,
                link:highlight.url,
                src:highlight.url,
                videoNotes:highlight.data,
            }
            //保存这个元素的笔记到缓存....
            videoCache.set(highlight.id,highlight.data);
            setLibraryData({videoNotes: {element:element},isVideo:true,name:highlight.name,id:data.id})
            setArrayBreadcrumb(createBreadcrumb(szType,data.name || highlight.name || t("Untitled")));
            mSliderContainerType = 'video';
        }

        if (type == 'card' || type == 'journal'){

        }else if (type == 'pdf'){
            setTimeout( () => {
                const iframe = document.getElementById("pdf-main-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    let nDelayTime = 50;
                    let szFilePath =  localStorage.getItem(KEY_FILE_DIR) + data.fileName;
                    if (checkIfAbsolute(data.fileName)){
                        szFilePath = data.fileName;
                    }

                    ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(async (res)=> {
                        const blob = new Blob([res]);
                        const url = URL.createObjectURL(blob);

                        if (szOldPdfFileId != data.id) {
                            const library = await getCardById(data.id);
                            iframe.contentWindow?.postMessage(JSON.stringify({
                                path: url,
                                fileId: data.id,
                                type: "open-pdf",
                                theme:getTheme(),
                                initialPage:library?.pageNumber || 1,
                                state:library?.state,
                                language:getLanguageCode()
                            }), {
                                targetOrigin: '*'
                            })
                            nDelayTime = 1200;

                            if (library?.pageNumber > 1){
                                message.success(t("RestoreLastPdfReadPos"))
                            }
                        }

                        setTimeout(()=>{
                            // iframe.contentWindow._reader?._updateState({colorScheme: localStorage.getItem(SYS_CONFIG_KEY_THEME)??THEME_LIGHT})
                            if (extra?.isViewAllHighlight){
                                iframe.contentWindow._reader.toggleSidebar(true)
                            }

                            if (extra?.highlightId){
                                iframe.contentWindow?.postMessage(JSON.stringify({
                                    type: 'highlights-location',
                                    id: extra.highlightId,
                                    time: 1000
                                }))
                            }

                        },600)
                    })
                }
            }, 600)
        }


        /**
         * 刷新一下.
         */
            //设置条目高度....
        setTimeout(() => {
            pageLibraryRef.current?.onSliderEvent(nWidth);
            sideProjectRef.current?.onResizeEvent(nWidth);
        }, 100);

        if (szSelectSliderRightMenu == 'project'){
            setSliderTitleImage('deeplink_project');
            sideProjectRef.current?.updateNoteList();
            if (sliderProjectData){
                //重打开的时候这里需要更新Project的数据--可能外面有更改....
                const resss:any = await getNoteById(sliderProjectData.id);
                resss.doc = JSON.parse(resss.doc);
                const selectBoard = sliderProjectData.doc.canvas.find(p=>p.isSelected);
                if (selectBoard){
                    for (let i=0;i<resss.doc.canvas.length;i++){
                        if (resss.doc.canvas[i].key == selectBoard.key){
                            resss.doc.canvas[i].isSelected = true;
                            break;
                        }
                    }
                }else{
                    resss.doc.canvas[0].isSelected = true;
                }
                setSliderProjectData(resss);
            }
        }else{
            setSliderTitleImage(null);
        }

        if (szSelectSliderRightMenu == 'info'){
            setTimeout(()=>{
                window.refreshInfo(mDataInfo.current);
            },100)
        }else if (szSelectSliderRightMenu == 'webview'){
            type = '';
        }

        if (type == 'journal' || data?.type == 'journal'){
            setLibraryData(null);
            mSliderContainerType = 'journal';
            szSelectSliderRightMenu = 'journal';
            setSelectSliderRightMenu(szSelectSliderRightMenu);
            setJournalData(data);
            setSliderProjectData(null);
        }
        else if (type == 'project'){
            setSliderTitleImage('deeplink_project');
            setSelectSliderRightMenu('project');
            setSliderProjectData(data);
        }else if (type == 'pdf' || type.type == 'video'){
            setSliderProjectData(null);
            setSelectSliderRightMenu('library');
        }else if (isAnnoType(type) || type == 'bilibili' || type == 'baidu' || type == 'youtube'){
            setSliderProjectData(null);
            setSelectSliderRightMenu('library');
        }else if (type == 'card' || data?.type == 'card'){
            setSliderProjectData(null);
            setSelectSliderRightMenu('library');
        }else if (type == 'highlight' || data?.type == 'highlight'){
            setSliderProjectData(null);
            setSelectSliderRightMenu('highlight')
        }
        else{
            setSliderProjectData(null);
            if (szSelectSliderRightMenu == 'webview'){
                setSelectSliderRightMenu('webview');
            }else{
                setSelectSliderRightMenu('library');
            }
        }


        if (data?.type == 'card' || data?.type == 'journal'){
            setTimeout(async () => {
                const blockId = sessionStorage.getItem('block-id')
                const blockType = sessionStorage.getItem('block-type')
                const ifFullScreen = sessionStorage.getItem('ifFullScreen')
                if (blockId && blockType) {
                    await sleep(200)
                    sessionStorage.removeItem('block-id')
                    sessionStorage.removeItem('block-type')
                    sessionStorage.removeItem('ifFullScreen')
                    await sleep(200)
                    if (blockType === 'highlight') {
                        const boundingNode = mEditorRef.current?.view.dom.querySelectorAll(`[data-id="${blockId}"]`)[0]
                        const boundingRect = boundingNode.getBoundingClientRect();
                        const scrollTop = mEditorRef.current?.view.dom.parentElement.parentElement.parentElement.scrollTop;
                        const clientHeight = document.documentElement.clientHeight;
                        const targetScroll = scrollTop + boundingRect.top - clientHeight / 2;
                        mEditorRef.current?.view.dom.parentElement.parentElement.parentElement.scrollTo({
                            top: targetScroll,
                            behavior: 'smooth' // 平滑滚动
                        });
                        const markRes = getMarkById(mEditorRef.current,blockId)
                        await sleep(800)
                        mEditorRef.current?.chain().focus().setTextSelection({ from: markRes?.pos, to: markRes?.end }).run()

                    } else {
                        const selectedNP = mEditorRef.current?.$doc.querySelectorAll(blockType, { id: blockId })[0];
                        if (selectedNP){
                            mEditorRef.current?.chain().focus().setNodeSelection(selectedNP.pos - 1).scrollIntoView().run();
                        }
                    }
                }
            }, 600)
        }
    }
    /**
     * 关闭侧栏
     */
    const onCloseSlider = ()=>{
        //这个右侧栏的 setSelectSliderRightMenu 是全局的，全局的使用的是drawindex使用的也是.....
        setSelectSliderRightMenu('');
        setRightSliderWidth(0);
        setLibraryData(null);
    }

    function onMouseMoveListener(e: any) {
        const yBottom = document.body.clientHeight - e.clientY;
        const TOP_OFFSET = 90;

        mMouseMovingTime = Date.now();

        //右边拖动。。。。。。。
        if (e.buttons == 1 && mIsSliderDownPress) {

            let nMinWidth = e.clientX;
            if (e.clientX < 250) {
                nMinWidth = 250;
            }
            let nWidth = document.body.clientWidth - nMinWidth;

            let nMinDefaultWidth = DEFAULT_SLIDER_WIDTH;
            // if (isSidebarExpand){
            //     nMinDefaultWidth -= 92;
            // }

            if (nWidth < nMinDefaultWidth) {
                nWidth = nMinDefaultWidth;
            }


            let nMaxWidth = document.body.clientWidth - 450 - homePaddingLeft;
            if (homePaddingLeft == 0){
                nMaxWidth = document.body.clientWidth - 530;
            }
            const divJournal = document.getElementById('div-journal-left-part');
            if (divJournal){
                if (nWidth > nMaxWidth){
                    nWidth = nMaxWidth;
                }
            }else{
                //全屏card
                nMaxWidth = document.body.clientWidth - 500 - homePaddingLeft;
                if (nWidth > nMaxWidth){
                    nWidth = nMaxWidth;
                }
            }

            setRightSliderWidth(nWidth);
            localStorage.setItem(KEY_SLIDER_RIGHT_WIDTH, nWidth + '');

            pageLibraryRef.current?.onSliderEvent(nWidth);
            sideProjectRef.current?.onResizeEvent(nWidth);
            pageHighlightRef.current?.onSliderEvent(nWidth);

            setIframePdfContainerPointerEvent('none');
            setLibraryContainerPointerEvent('none');
            setIsDragLine(true);

            mSliderX = e.clientX;

            e.preventDefault();
            e.stopPropagation();
        } else {
            setIframePdfContainerPointerEvent('all');
            setLibraryContainerPointerEvent('all');
            setIsDragLine(false);
        }
    }

    function onMouseUpListener(event) {
        mIsSliderDownPress = false;
        mIsSliderLibraryDownPress = false;
        mIsSliderCommonDownPress = false;
        setIsDragLine(false);
    }


    //关闭全局的右侧栏
    window.closeGlobalRightSide = ()=>{
        onCloseSlider();
    }

    /**
     * 刷新info
     * @param data
     */
    window.refreshInfo = (data:any)=>{
        if (selectSliderRightMenu == 'info'){
            mDataInfo.current = data;

            setSliderTitleInfo({
                image:getImageNameFromdeepLinkType(data?.type,null),
                title: data?.name
            })

            sideInfoRef.current?.onShowDialog('library',data,false);
        }
    }

    /**
     * 画布页面刷新info
     * @param szType
     * @param data
     */
    window.refreshInfoInDraw = (szType,data)=>{
        if (selectSliderRightMenu == 'info'){
            if (!data){
                setSliderTitleInfo(null);
            }else{
                mDataInfo.current = data;
                setSliderTitleInfo({
                    image:getImageNameFromdeepLinkType(data?.type,null),
                    title: data?.name
                })
                sideInfoRef.current?.onShowDialog(szType,data,false);
            }
        }
    }

    useEffect(()=>{
        window.closeRightSliderSearch = ()=>{
            setIsSearching(false);
        }
        window.refreshRightSliderTitle = (szTitle:any)=>{
            setTitle(szTitle);
        }
        return ()=>{
            delete window.closeGlobalRightSide;
            delete window.refreshInfo;
            delete window.closeRightSliderSearch;
            delete window.refreshRightSliderTitle;
        }
    },[])

    useEffect(()=>{
        //接收update消息
        recvMessage(EVENT_SYNC_CARD_DATA_FROM_PAGECARD,(msg,data)=>{
            const card = data.data.data;
            if (libraryData?.id == card.id){
                const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
                if (isStringNullOrEmpty(removeHtmlTags(card.doc)) && isEmptyTitle && card.doc.indexOf('<img') == -1){
                    return;
                }

                card.type = card.type || mSliderContainerType;
                setLibraryData(card);
                // updateCard(card,true,true,'fromCanvasListIndex-EVENT_UPDATE_NOTE').then((res)=>{
                //
                // });
            }
        })

        document.body.addEventListener('mousemove', onMouseMoveListener);
        document.body.addEventListener('mouseup', onMouseUpListener);
        //监听iframe dialogdrawindex发送的消息....
        window.addEventListener('message', windowMessageEvent);


        return () => {
            window.removeEventListener('message', windowMessageEvent);
            document.body.removeEventListener('mousemove', onMouseMoveListener);
            document.body.removeEventListener('mouseup', onMouseUpListener);
            unSubscribe(EVENT_SYNC_CARD_DATA_FROM_PAGECARD);

        }
    })

    useEffect(() => {
        if (libraryData?.type == 'pdf'){
            window.refreshList['updatePdfAnnoComment_'+libraryData.id] = ()=>{
                iframeRef.current?.contentWindow?.postMessage(JSON.stringify({
                    fileId: libraryData.id,
                    type: "refresh-annotations"
                }), {
                    targetOrigin: '*'
                })
            }
        }

        //右侧栏打开这个，然后又在弹窗/全屏中打开，然后又通过菜单将其删了。---步骤越多，操作越复杂---
        window.refreshList['rightSlider_reset_when_del'] = (data)=>{
            if (data && data?.id == libraryData?.id){
                setRightSliderWidth(0);
                setLibraryData(null);
            }
        }

        return ()=>{
            if (libraryData?.type == 'pdf') {
                delete window.refreshList['updatePdfAnnoComment_' + libraryData.id];
            }
            delete window.refreshList['rightSlider_reset_when_del'];
        }

    }, [libraryData]);


    /**
     * 接收iframe的消息.....
     * @param event
     */
    const windowMessageEvent = async(event: any) => {
        if (event?.data){
            if (event.data.action == 'selectBoard' && sliderProjectData){
                const newData = {...sliderProjectData};
                let doc = newData.doc;
                if (doc && isString(doc)){
                    doc = JSON.parse(doc);
                }
                newData.doc = doc;
                for (let i=0;i<doc.canvas.length;i++){
                    doc.canvas[i].isSelected = false;
                    if (doc.canvas[i].key == event.data.data){
                        doc.canvas[i].isSelected = true;
                    }
                }
                setSliderProjectData(newData);
            }else if (event.data.action == 'switchBoardSelect'){
                //slider 给 draw发消息，切换board...
                // const selectBoard = event.data.data;
                // leftMenuRef.current?.onNavSelectedItem(selectBoard.key);
            }else if (event.data.action == EVENT_PDF_ON_SLIDER_RIGHT){
                //slider->draw 打开PDF
                //这里要重新处理pdfPath
                const library:any = await getCardById(event.data.data.data.fileId);
                if (library){
                    let szFilePath = '';
                    if (library.isAbsolutePath){
                        szFilePath = library.fileName;
                    }else{
                        szFilePath = localStorage.getItem(KEY_FILE_DIR)+library.fileName;
                    }
                    ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                        const blob = new Blob([res]);
                        const url = URL.createObjectURL(blob);
                        event.data.data.data.pdfPath = url;
                        postMessage(EVENT_PDF_ON_SLIDER_RIGHT,event.data.data.data)
                    });
                }else{
                    message.error('open failed.');
                }
            }else if (event.data.action == EVENT_NOTE_ON_SLIDER_RIGHT){
                postMessage(EVENT_NOTE_ON_SLIDER_RIGHT,event.data.data.data)
            }else if (event.data.action == EVENT_VIDEO_ON_SLIDER_RIGHT){
                postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT,event.data.data.data)
            }else if (event.data.action == "UPDATE_CARD_FROM_DRAW"){
                //draw-->to sidebar更新card...
                // excalidrawRef.onUpdateCardElement(event.data.data);
            }else if (event.data.action == 'SYNC_DRAW_BOARD'){
                //sidebar --> draw  同步board...
                // if (mNoteData.current?.id == event.data.data.id){
                //     //同一个项目..
                //     const currentBoard = leftMenuRef.current?.onGetSelectNode();
                //     const sidebarBoard = JSON.parse(event.data.data.board);
                //     sidebarBoard.icon = <IconPageBlack/>
                //     if (currentBoard.key != sidebarBoard.key){
                //         //不是同一个board...更新board.
                //         leftMenuRef.current?.onUpdateBoard(sidebarBoard);
                //     }
                // }
            }else if (event.data.action == 'refresh-canvas-card'){
                //刷新画布上的card...
                const data = event.data.data;
                data.customData = {generationData:{...data,html:data.doc}}
                postMessage(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,data)
            }
        }
    }

    /**
     * sliderDraw 给draw 发送消息
     * @param szAction
     * @param data
     */
    const sendMessageFromSliderDraw = (szAction,data)=>{
        window.parent.postMessage({action:szAction,data:data})
    }

    /**
     * 给 sliderDraw发消息
     * @param szAction
     * @param data
     */
    const sendMessageFromDraw = (szAction,data)=>{
        const iframe = document.getElementById('iframe-slider-global-drawindex-container');
        if (iframe){
            iframe.contentWindow.postMessage({action:szAction,data:data})
        }
    }

    /**
     * 关闭右侧弹窗
     */
    const animateSliderFade = async () => {
        setRightSliderWidth(0);

        if (mSliderContainerType == "pdf") {
            // setFileState({
            //     open: true,
            //     fileName: pdfFileName,
            //     filePath: pdfFilePath,
            //     fileId: pdfFileId
            // })
        } else if (mSliderContainerType == 'card') {
            //save card
            const data = await editorRef.current?.save?.();
            postMessage(EVENT_UPDATE_NOTE, {data, isInsertCanvas: false});
        }
        mSliderContainerType = '';
    }

    /**
     * 右侧PDF更多
     */
    const getSliderMoreItems = () => {
        if (mSliderContainerType == "pdf") {
            return [
                getItem(t("Open in popup"), 'openPdfInPopup', <IconOpenInPopup/>, undefined, undefined, () => {
                    onSliderClickMenu('openPdfInPopup')
                }),
                getItem(t("Open in fullscreen"), 'openPdfInFullScreen', <IconOpenInFullscreen/>, undefined, undefined, () => {
                    onSliderClickMenu('openPdfInFullScreen')
                }),

                getItem(t("Export as Pdf"), 'pdfExport', <IconMenuExportItem/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfExport')
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                getItem(t("Rename"), 'pdfRename', <IconRename/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfRename')
                }),
                getItem(t("Search"), 'pdfSearch', <IconSearch/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfSearch')
                }),
                getItem(t("View all highlights"), 'pdfViewHighlights', <IconViewAllHighlight/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfViewHighlights')
                }),
                getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, () => {
                    onSliderClickMenu('showInfo-pdf')
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                    onSliderClickMenu('copyLink-pdf')
                }),
                getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, () => {
                    onSliderClickMenu('manageTags-pdf')
                }),
                getItem(t("Add to project"), 'addToProject', <IconAddToProject/>, undefined, undefined, () => {
                    onSliderClickMenu('addToProject-pdf')
                }),
                getItem(t("Delete"), 'pdfDelete', <IconDelete/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfDelete')
                }),
            ]
        } else if (mSliderContainerType == 'card') {
            const MENU_MORE: MenuItem[] = [
                getItem(t("Open in popup"), 'openInPopup', <IconOpenInPopup/>, undefined, undefined, () => {
                    onSliderClickMenu('openInPopup')
                }),
                getItem(t("Open in fullscreen"), 'openInFullScreen', <IconOpenInFullscreen/>, undefined, undefined, () => {
                    onSliderClickMenu('openInFullScreen')
                }),
                getItem(t("ExportPDF"), 'exportPdf', <IconMenuExportItem/>, undefined, undefined, async () => {
                    onSliderClickMenu('exportPdf')
                }),
                getItem(t("ExportMarkdown"), 'exportMarkdown', <IconMenuExportItem/>, undefined, undefined, (e) => {
                    onSliderClickMenu('exportMarkdown')
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                // getItem(t("ShowInfo"), 'showInfo', null, undefined, undefined, () => {
                //   window.GOpenCountWords();
                // }),
                getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, () => {
                    // @ts-ignore
                    onSliderClickMenu('rename')
                }),
                getItem(libraryData?.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"), 'favor', libraryData?.isFavirated === 1?<IconRemoveFavor/>:<IconAddToFavor/>, undefined, undefined, async () => {
                    const ccccccc = await editorRef.current?.save?.();
                    await updateCard({
                        ...ccccccc,
                        type: 'card',
                        isFavirated: (libraryData?.isFavirated == 1) ? 0 : 1
                    }).then(res=>{
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                    });
                    const card:any = await getCardById(libraryData?.id, true);
                    setLibraryData(card);
                }),
                getItem(t("Generic copy"), 'makeCopy', <IconMakeCopy/>, undefined, undefined, async () => {
                    onSliderClickMenu("makeACopy")
                }),
                getItem(t("Search"), 'search', <IconSearch/>, undefined, undefined, () => {
                    onSliderClickMenu('search');
                }),
                getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, async () => {
                    const saveData: any = await editorRef.current?.getSaveData();
                    const cardData:any = {...libraryData};
                    cardData.doc = saveData.doc;
                    cardData.name = saveData.name;
                    cardData.type = 'card';
                    if (!cardData.name) {
                        cardData.name = t("Untitled");
                    }
                    if (!cardData.createTime) {
                        cardData.createTime = Date.now();
                        cardData.updateTime = Date.now();
                    }
                    window.showInfo('library', cardData)
                }),
                getItem(<div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory', <IconVersionHistory/>, undefined, undefined, () => {
                    //历史记录
                    window.showDialogCardHistory(libraryData?.id,(newCard:any)=>{
                        //更新本界面
                        setLibraryData(newCard);
                        //更新画布
                        // postMessage(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,{id:newCard.id,customData:{generationData:{html:newCard.doc,name:newCard.name}}});
                        //更新侧栏
                    });
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),

                getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                    createCopyLink('library', libraryData.id, null, null);
                }),

                getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, async () => {
                    //如果是新建的card,操作标签前先保存这个card
                    let card: any = await getCardById(libraryData?.id, false);
                    let ddddddatatataat = libraryData;

                    if (!card) {
                        // logger('save as a new card....');
                        const ccccccc = await editorRef.current?.save?.();
                        await updateCard({
                            ...ccccccc,
                            type: 'card'
                        }, true, true, 'fromManageTag');
                        card = await getCardById(libraryData.id, true);
                        setLibraryData(card);
                        ddddddatatataat = card;
                        global.g_currentNoteData = card;

                        // logger('a new card....');
                        // logger(ddddddatatataat);
                    }
                    window.showManageTags([ddddddatatataat]);
                }),
                getItem(t("Add to project"), 'addToProject', <IconAddToProject/>, undefined, undefined, async () => {
                    const ccccccc = await editorRef.current?.save?.();
                    await updateCard({
                        ...ccccccc,
                        type: 'card',
                        isFavirated: (libraryData.isFavirated == 1) ? 0 : 1
                    })
                    const card:any = await getCardById(libraryData.id, true);
                    setLibraryData(card);
                    window.showDialogChooseProject([card])
                }),

                getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
                    onSliderClickMenu('delete')
                }),
            ];
            return MENU_MORE;
        }else if (mSliderContainerType == 'library' || mSliderContainerType == 'video' || mSliderContainerType == 'highlight'){
            return getVideoSliderMenu(libraryData?.videoNotes?.element?.link);
        }
        return [];
    }

    const getVideoSliderMenu = (link:any)=>{
        let arrayLibraryMenus = createLibraryItemMenu('slider',false,{type:isAudio(link)?'audio':'video',link:link},null);
        const arrayMenus = [];
        arrayMenus.push({
            label: t("Open in popup"),
            key: 'openInPopupVideo',
            icon: <IconOpenInPopup/>
        })
        if (!isAudio(link)){
            arrayMenus.push({
                label: t("Open in fullscreen"),
                key: 'openInFullscreenVideo',
                icon: <IconOpenInFullscreen/>
            })
        }

        arrayMenus.push({
            key:'seper_1',
            type:'divider'
        })
        arrayMenus.push(...arrayLibraryMenus);
        return arrayMenus;

        /*
        return [
            getItem(t("Open in popup"), 'openInPopup', null, undefined, undefined, async () => {
                const highlight = await dbGetHighlightByLibraryId(libraryData.id);
                if (highlight) {//有视频注记，用视频注记打开
                    window.showVideoNotes(highlight,null);
                }else {
                    window.showDialogMediaView(libraryData);
                }
            }),
            getItem(t("Open in fullscreen"), 'openInFullscreen', null, undefined, undefined, async () => {
                const highlight = await dbGetHighlightByLibraryId(libraryData.id);
                if (highlight) {//有视频注记，用视频注记打开
                    window.showVideoNotes(highlight,null,'fullScreen');
                }else {
                    window.showDialogMediaView(libraryData);
                }
            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            getItem(t("Export txt"), 'exportTxt', null, undefined, undefined, () => {
                const videoNotes = libraryData.videoNotes.element?.videoNotes;
                if (videoNotes){
                    saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(videoNotes));
                }else{
                    message.error(t("No data"))
                }
            }),
            getItem(t("Copy to clipboard"), 'copyToClipboard', null, undefined, undefined, () => {
                //获取内容
                const videoNotes = libraryData.videoNotes.element?.videoNotes;
                if (videoNotes){
                    let szTxt = '';
                    for (let i=0;i<videoNotes.length;i++){
                        let item = videoNotes[i];
                        szTxt += `[timestamp]:${getTimeText(item.time)}\n${item.title}${item.title?'\n':''}${item.content}\n\n`;
                    }
                    clipboard.write(szTxt);
                    message.info(t("Copied to clipboard"))
                }else{
                    message.error(t("No data"))
                }
            }),
        ]*/
    }

    const exportCurrentElementVideoNotes = (elementVideoNotes) => {
        const exportValues = {
            videoTitle: formatDate(new Date(),'yyyyMMddhhmmss'),
            pastedText: elementVideoNotes.reduce((pre, item) => {
                return `${pre}[timestamp]:${getTimeText(item.time)}
${item.title}
${item.content}
`;
            }, ""),
        };
        return exportValues;
    };

    async function getSaveData() {
        window.GSearchClose?.()
        const data = await editorRef.current?.save?.();
        hideLoad()
        return data;
    }


    /**
     * 右侧更多的点击事件
     * @param key
     */
    const onSliderClickMenu = async (key: string) => {
        if (!isString(key)){
            key = key.key;
        }
        switch (key) {
            case "openPdfInPopup":
                window.showPdfPreview(libraryData.name, libraryData.id, libraryData.fileName);
                break;
            case "openPdfInFullScreen":
                window.showPdfPreview(libraryData.name,libraryData.id,libraryData.fileName,true,false,false);//{highlightId:library.id}
                break;
            case "pdfRename": {
                window.showCommonInput(libraryData.name,t("Rename"),"",t("Cancel"),t("Save"),(szContent:string)=> {
                    window.closeCommonInput();
                    var dataNew = {...libraryData,name:szContent};
                    setLibraryData(dataNew);

                    setArrayBreadcrumb(createBreadcrumb(mBreadcrumbType,dataNew.name || t("Untitled")));

                    renameCardById(libraryData.id,szContent).then(res=>{
                        postMessage(EVENT_REFRESH_DEEPLINK_TITLE,{data:dataNew})
                    });
                });
                break;
            }
            case "pdfSearch": {
                const iframe = document.getElementById("pdf-main-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    iframe.contentWindow._reader?.toggleFindPopup({primary: true, open: true})
                }
            }
                break;
            case "pdfViewHighlights": {
                const iframe = document.getElementById("pdf-main-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    iframe.contentWindow._reader?.toggleSidebar(true)
                }
            }
                break;
            case "pdfExport": {
                const iframe = document.getElementById("pdf-main-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    message.loading({
                        key: "export-loading",
                        type: "loading",
                        content: t("Exporting")
                    })
                    const szFileName = libraryData?.fileName;
                    const szData = JSON.stringify({
                        isAnnotations: true,
                        fileName: szFileName,
                        type: "download-pdf"
                    });
                    iframe.contentWindow?.postMessage(szData, {
                        targetOrigin: '*'
                    })
                }
                break;
            }
            case  "pdfDelete": {
                window.showMessageBox(t("Tips"), t("ConfirmDeleteLibraryItem"),t("Cancel"), t("Confirm"),null, async () => {
                    postMessage(EVENT_DELETE_ELEMENT_BY_ID, {id:libraryData.id});
                    setRightSliderWidth(0);
                    //从库中删除
                    const library:any = await getCardById(libraryData.id);
                    if (library){
                        library.isDeleted = 1;
                        updateCard(library).then(r=>{
                            postMessage(EVENT_REFRESH_LIBRARY_LIST);
                        })
                    }
                });

                break;
            }
            case "openInPopup": {
                //关闭这里.
                // onCloseSlider();
                const noteData = await editorRef.current?.save?.();
                postMessage(EVENT_UPDATE_NOTE, {data: noteData, isInsertCanvas: false});
                global.g_currentNoteData = noteData;
                // Global.g_isNotePopupWindow = true;
                setTimeout(() => {
                    openEditor(libraryData?.id, true)
                }, 40);
            }
                break;
            case "openInFullScreen": {
                //关闭这里.
                onCloseSlider();
                const noteData = await editorRef.current?.save?.();
                postMessage(EVENT_UPDATE_NOTE, {data: noteData, isInsertCanvas: false});
                global.g_currentNoteData = noteData;
                // Global.g_currentNoteFullScreen = true;
                //
                // setTimeout(() => {
                //     setCardFullScreen(true);
                //     openEditor(mSliderCardId)
                // }, 40);
                window.navigate(getCardPath(),{cardId:libraryData?.id})
            }
                break;
            case "exportPdf":
            case "exportVideo":
            case "exportAudio":
            case "exportFile":
                if (libraryData.type == 'card'){
                    const data = await getSaveData()
                    const name = getCardTitle(data);
                    //保存到doc
                    editDoc((data.id || LASTEST_NOTE_DOC), data.doc, data.name).then(res => {
                        setTimeout(() => {
                            ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
                        }, 10);
                    })
                }else{
                    //导出文件
                    getCardById(libraryData.id).then((item:any)=>{
                        const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
                        ipcSend('saveFile', {
                            filters: [{name: "All file", extensions: ['*']}],
                            filePath: szFilePath,
                            fileName: item.name+'.'+getFileNameExt(item.fileName)
                        })
                    })
                }
                break;
            case "exportMarkdown":
                const data0 = await getSaveData()
                // excalidrawRef?.onExportSingleMd(data0);
                window.exportMarkdown(data0);
                break;
            case "makeACopy":
                const noteSimpleData = await getSaveData();
                postMessage(EVENT_COPY_DOC_NOTE, noteSimpleData);
                message.info(t("Copyed"))
                break;
            case "rename":
                getCardById(libraryData.id).then((item:any)=>{
                    if (item.type == 'card'){
                        editorRef.current?.rename?.()
                    }else{
                        window.showCommonInput(item.name,t("Rename"),"",t("Cancel"),t("Save"),(szContent:string)=>{
                            window.closeCommonInput();
                            item.name = szContent;
                            renameCardById(item.id,szContent).then(res=>{
                                //不知道啥排序，直接刷新列表。。
                                if (selectSliderRightMenu == 'library'){
                                    setArrayBreadcrumb(createBreadcrumb('library',item.name))
                                }else if (selectSliderRightMenu == 'highlight'){
                                    setArrayBreadcrumb(createBreadcrumb('highlight',item.name))
                                }
                            });
                        });
                    }
                })

                break;
            case "delete":
                window.showMessageBox(t("Tips"), t("ConfirmDeleteLibraryItem"),t("Cancel"), t("Confirm"), null,() => {
                    if (libraryData) {
                        if (libraryData.type == 'card'){
                            global.g_deletedCardIds[libraryData?.id] = true;
                            postMessage(EVENT_DELETE_HTML_NOTE, {id: libraryData?.id});
                        }

                        getCardById(libraryData.id).then(res=>{
                            if (res){
                                res.isDeleted = 1;
                                updateCard(res).then(res=>{
                                    setRightSliderWidth(0);
                                    setLibraryData(null);

                                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                });
                            }
                        })
                    }
                });
                break;
            case "copyLink":
                createCopyLink("library", libraryData.id,libraryData.type,null);
                break;
            case "search":
                window.GSearchOpen?.()
                break;
            case "showInfo":
            case "showInfo-pdf":
                getCardById(libraryData.id)?.then(res=>{
                    window.showInfo('library',res);
                })
                break;
            case "showInSystemExporler":
                getCardById(libraryData.id).then((item:any)=>{
                    ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
                })
                break;
            case "importHighlights":
                //导入--笔记
                window.showDialogImportHighlight((file,content)=>{
                    videoContentRef.current?.onImportHighlights(file,content);
                });
                break;
            case "importTranscript":
                //导入--字幕
                window.showDialogImportTranscript((file,content)=>{
                    let arrayResults = importTranscriptFromContent(content);
                    //保存....
                    if (arrayResults && arrayResults.length > 0) {
                        updateTranscript({
                            id: libraryData.videoNotes.element.customData?.generationData?.id,
                            data: arrayResults
                        }).then(res => {
                            window.globalRefreshList('refresh_transcript_');
                            window.globalRefreshList('switch_to_transcript_');
                        });
                    }
                })
                break;
            case "exportHighlights":
                //导出注记
                videoContentRef.current?.saveExportElementVideoNotes();
                break;
            case "copyToClipboard":
                const text = videoContentRef.current!.getCurrentElementVideoNotes();
                await navigator.clipboard.writeText(text);
                message.info(t('Notes copied to clipboard'))
                break;
            case "manageTags-pdf":
                getCardById(libraryData.id)?.then(res=>{
                    window.showManageTags([res]);
                })
                break;
            case "addToProject":
            case "addToProject-pdf":
                getCardById(libraryData.id).then(res=>{
                    window.showDialogChooseProject([res],res.name)
                })
                break;
            case "copyLink-pdf":
                createCopyLink('library',libraryData.id,'pdf');
                break;
            case "openInPopupVideo":
                window.showVideoNotesWithElement(libraryData?.videoNotes?.element,false);
                break;
            case "openInFullscreenVideo":
                window.showVideoNotesWithElement(libraryData?.videoNotes?.element,true);
                break;
            case "managerTags":
                getCardById(libraryData.id).then(item=>{
                    window.showManageTags([item]);
                })
                break;
        }
    }

    /**
     * 处理头部的点击事件
     * @param szAction
     */
    const drawIndexSliderHeaderAction = (szAction:any)=>{

        setArrayBreadcrumb([]);
        setLibraryData(null);
        setSliderTitleImage(null);
        if (szAction != selectSliderRightMenu){
            setSearchKey('');
            setIsSearch(false);
        }
        if (selectSliderRightMenu == 'project'){
            setSliderProjectData(null);
        }
        mSliderContainerType = localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) || 'library';
        if (szAction == 'collapse') {
            setRightSliderWidth(0);//如果是打开的card/pdf等也关闭
            setLibraryData(null);
            setArrayBreadcrumb([]);
            setSliderHeaderVisible(false);
        }else if (szAction == 'refresh'){
            if (mSliderContainerType == 'journal'){
                // setLibraryData()
            }
            //设置条目高度....
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setTimeout(() => {
                pageLibraryRef.current?.onSliderEvent(nWidth);
            }, 100)
        }else if (szAction == 'project'){
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setTimeout(() => {
                sideProjectRef.current?.onResizeEvent(nWidth);
            }, 100);
            setSliderTitleImage('deeplink_project');
        }else if (szAction == 'library'){
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            // if (selectSliderRightMenu != 'library' && libraryData?.type == 'card'){
            //     setArrayBreadcrumb(createBreadcrumb('library',libraryData.name));
            //     setRightSliderWidth(nWidth);
            // }else{
            //
            // }
            if (pageLibraryRef.current){
                pageLibraryRef.current?.onSliderEvent(nWidth);
            }else{
                setTimeout(() => {
                    pageLibraryRef.current?.onSliderEvent(nWidth);
                }, 100)
            }
        }else if (szAction == 'info'){
            setTimeout(()=>{
                setSliderTitleInfo({
                    image:getImageNameFromdeepLinkType(mDataInfo.current?.type,null),
                    title: mDataInfo.current?.name
                })
                sideInfoRef.current?.onShowDialog('library',mDataInfo.current,false);
            },100)
        }
    }

    /**
     * 导航条目点击，主要是返回第一个...
     * @param breadcrumbItem
     */
    const drawIndexBreadcrumbAction = (breadcrumbItem:any)=>{
        setLibraryData(null);
        setArrayBreadcrumb([]);

        let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
        //设置条目高度....
        setTimeout(() => {
            pageLibraryRef.current?.onSliderEvent(nWidth);
            sideProjectRef.current?.onResizeEvent(nWidth);
        }, 100)

        if (breadcrumbItem.type == 'library'){

        }else if (breadcrumbItem.type == 'journal'){

        }else if (breadcrumbItem.type == 'highlight'){

        }
    }


    const getSliderTitle = ()=>{
        if (selectSliderRightMenu == 'library') {
            return t("Library")
        }else if(selectSliderRightMenu == 'highlight') {
            return t("Highlights")
        }else if (selectSliderRightMenu == 'project'){
            return t("Projects");
        }
        return '';
    }

    const getProjectSrc = ()=>{
        // sliderProjectData ? (DEBUG ? `/#/sliderDraw/${sliderProjectData?.id}` : global.g_base_url + `#sliderDraw/${sliderProjectData?.id}`) : ''
        if (!sliderProjectData){
            return '';
        }

        let szSrc = '';
        if (DEBUG){
            szSrc = `/#/sliderDraw/${sliderProjectData?.id}`;
        }else{
            szSrc = global.g_base_url + `#sliderDraw/${sliderProjectData?.id}`;
        }

        if (mExtra.current?.pageId){
            szSrc += '/'+mExtra.current.pageId;
        }
        if (mExtra.current?.elementId){
            szSrc += '/'+mExtra.current.elementId;
        }
        if (mExtra.current?.nodeId){
            szSrc += '/'+mExtra.current.nodeId;
        }
        return szSrc;
    }

    /**
     * 渲染右侧栏的board
     */
    const renderSliderProjectBoard = ()=>{
        let doc = sliderProjectData?.doc;
        if (doc && isString(doc)){
            doc = JSON.parse(doc);
        }
        //如果没有选中的，默认设置第一个选中
        if (doc?.canvas){
            const hasSelected = doc?.canvas?.some(p=>p.isSelected);
            if (!hasSelected){
                doc.canvas[0].isSelected = true;
            }
        }

        return(
            <div style={{minWidth:'160px',padding:'12px 0'}}>
                <span style={{marginLeft:'16px',marginBottom:'6px',display:'block'}}>{t("Board")}</span>
                {
                    // doc &&
                    doc?.canvas?.map(p=>{
                        return(
                            <div className={'flex-row-vertical-center hovered-blue'} style={{height:'36px',padding:'0 12px'}} onClick={()=>{
                                //切换sliderdraw中的board....
                                setIsShowPopupBoard(false);
                                sendMessageFromDraw('switchBoardSelect',p);
                            }}>
                                <img className={'img-16'} style={{opacity:p.isSelected?'1':'0'}} src={getImagePathWithTheme('check_black')}/>
                                <span className={'ml-4 default-font-size'}>{p.title}</span>
                            </div>
                        )
                    })
                }
            </div>

        );
    }

    /**
     * 搜索的间距，不一样，都...
     */
    const getSearchMargin = ()=>{
        if (libraryData?.isVideo){
            return '0 12px 0 12px';
        }
        if (selectSliderRightMenu == 'library' || selectSliderRightMenu == 'highlight' || selectSliderRightMenu == 'project'){
            return '0 4px 0 16px';
        }
        return '0px';
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "inherit" : "inherit"}}
                        onClick={() => {
                            mSearchKey = '';
                            setSearchKey('');
                            pageLibraryRef.current?.onSearchEvent('');
                            pageHighlightRef.current?.onSearchEvent('');
                            videoContentRef.current?.onSearch('');
                            sideProjectRef.current?.onSearch('');
                            setIsSearch(false);
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }


    return (
        <div className={'float-popup flex-row'} id={'div-slider-right'} data-type={'noDrag'} style={{
            width: rightSliderWidth + 'px',
            top: isMac() ? '0' : ((APP_WEB_WWW || APP_WEB) ? '0px' : '30px'),
            height: '100%',
            overflow: 'hidden',
            fontSize: '13px',
            paddingBottom: '0px',
            background: 'var(--right-slider-background-color)'
        }}>
            <div className={'drag-line'} onMouseDown={(event) => {
                mSliderX = event.clientX;
                mIsSliderDownPress = true;
                // event.preventDefault();
            }}>&nbsp;</div>
            <div style={{
                width: '100%',
                height: isMac() ? '100vh' : `calc(100vh - ${TITLE_BAR_HEIGHT}px)`,
                display: 'flex',
                flexDirection: 'column',
                marginLeft: '0px'
            }}>

                {/*//头部*/}
                {
                    sliderHeaderVisible &&
                    <DrawIndexSliderHeader onAction={(szAction: any) => {
                        drawIndexSliderHeaderAction(szAction);
                    }}/>
                }

                {
                    (selectSliderRightMenu == 'journal' || selectSliderRightMenu == 'info' || selectSliderRightMenu == 'webview' || sliderProjectData)?<></>:
                    <div className={'flex-row-vertical-center'}
                         style={{padding: '0px 12px 0px 4px', minHeight: `${HEADER_HEIGHT}px`}}>
                        {
                            libraryData?.type == 'card' &&
                            <img className='img-32 hovered-gray-radius ml-8' onClick={() => {
                                sideBarFoldRef.current?.onToggleBar();
                            }} src={getImagePathWithTheme('left_slider_2.svg')}/>
                        }

                        {
                            !isSearch &&
                                <>
                                {
                                    (sliderHeaderVisible && libraryData?.type != 'card') ?
                                        //导航
                                        <DrawIndexBreadcrumb arrayBreadcrumb={arrayBreadcrumb}
                                                             onAction={(breadcrumbItem: any) => {
                                                                 drawIndexBreadcrumbAction(breadcrumbItem);
                                                             }}/> : <>
                                            {
                                                libraryData?.type != 'card' &&
                                                <img className={'img-14 cursor-pointer ml-8'}
                                                     src={getImagePathWithTheme('collapse_library')}
                                                     onClick={async () => {
                                                         //open card or pdf
                                                         animateSliderFade()
                                                     }}/>
                                            }
                                            <div className={'dialog-title'} style={{
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                margin: '2px 8px 0px 8px'
                                            }}>{title}</div>
                                        </>
                                }
                                </>

                        }

                        {
                            <div className={'flex-row-vertical-center'} style={{flexShrink:'0'}} onClick={() => {
                                // setRightSliderLibraryWidth(0);
                            }}>
                                {
                                    sliderTitleImage && !isSearch &&
                                    <img className={'img-14 mr-6'} src={getImagePathWithTheme(sliderTitleImage)}/>
                                }
                                {
                                    !isSearch && arrayBreadcrumb?.length == 0 &&
                                    <span className={'ml-1'}>{getSliderTitle()}</span>
                                }
                            </div>
                        }


                        {
                            isSearch && (!libraryData || libraryData?.isVideo) && selectSliderRightMenu != 'info' &&
                            <Input prefix={<IconHomeSearch/>} id={'input-main-library-search'}
                                   suffix={renderSuffix()}
                                   variant={"borderless"}
                                   style={{
                                       width: '100%',
                                       height: '32px',
                                       backgroundColor: 'var(--input-background-color)',
                                       margin: getSearchMargin()
                                   }}
                                   placeholder={searchPlaceholder} value={searchKey}
                                   onChange={(event) => {
                                       mSearchKey = event.currentTarget.value;
                                       setSearchKey(event.currentTarget.value);
                                       let szSearch = event.currentTarget.value.toLowerCase();
                                       if (selectSliderRightMenu == 'library') {
                                           if (libraryData?.isVideo) {
                                               videoContentRef.current?.onSearch(szSearch);
                                           }else {
                                               setIsSearching(true);
                                               pageLibraryRef.current?.onSearchEvent(szSearch);
                                           }
                                       } else if (selectSliderRightMenu == 'highlight') {
                                           pageHighlightRef.current?.onSearchEvent(szSearch);
                                       }else if (selectSliderRightMenu == 'project') {
                                           setIsSearching(true);
                                           sideProjectRef.current?.onSearch(szSearch);
                                       }
                                   }}
                            />
                        }

                        <div style={{flexGrow: '1'}}></div>

                        {
                            //视频截图。。。。
                            libraryData && !isSearch && libraryData?.isVideo && !isAudio(libraryData.videoNotes?.element?.customData?.generationData?.fileName) && HAS_VIDEO_CAPTURE_TEST &&
                            <img className={'img-16 cursor-pointer mr-2'} style={{display:'block',marginTop:'0px'}} src={getImagePathWithTheme('video_capture')} onClick={() => {
                                videoContentRef.current?.onGetCapture().then(async (res)=>{
                                    if (res == 'data:,'){
                                        message.error(t("PleasePlayBefore"));
                                        return;
                                    }
                                    const blob = base64ToBlob(res,'image/png');
                                    const item = new ClipboardItem({'image/png':blob})
                                    await navigator.clipboard.write([item]);
                                    window.showMessageBox(t("ScreenshotCopiedToClipboard"),t("YouCanDownload"),t("Download"),t("OK"),async ()=>{
                                        const library = await getCardById(libraryData.videoNotes?.element.customData?.generationData?.id || libraryData.videoNotes?.element.id);
                                        ipcSend('saveFile',{streamType:'image',stream:res.split(',')[1],filters:'[{ name: \'Images\', extensions: [\'png\'] }]',fileName:library?.name +'.png'});
                                    },null)
                                })
                            }}/>
                        }

                        {
                            !isSearch && (libraryData?.type == 'pdf' || libraryData?.type == 'card') &&
                            <img className={'img-16 cursor-pointer mr-12'} src={getImagePathWithTheme('context_menu_info.svg')} onClick={()=>{
                                getCardById(libraryData.id).then(res=>{
                                    window.showInfo('library',res);
                                })
                            }}/>
                        }

                        {/*card 卡片分享 发布*/}
                        {
                            libraryData?.type == 'card' &&
                            <Tooltip overlayClassName='font-size-12' title={t('Share')} zIndex={9999} arrow={false}>
                                <img className='img-25 hovered-gray-radius ml-0' style={{marginLeft:'-6px',marginRight:'2px'}} onClick={() => {
                                    window.showDialogPublishCardToWeb(libraryData.id,async (szId,dialogPublishToWebRef)=>{
                                        if (szId == 'exportPdf') {
                                            onSliderClickMenu('exportPdf')
                                        }else if (szId == 'exportMarkdown'){
                                            onSliderClickMenu('exportMarkdown')
                                        }
                                        else {
                                            shareCardData(libraryData,null,dialogPublishToWebRef);
                                        }
                                    });
                                }} src={getImagePathWithThemeSvg('share_card')}/>
                            </Tooltip>
                        }

                        {
                            !isSearch && selectSliderRightMenu != 'journal' && selectSliderRightMenu != 'info' && (arrayBreadcrumb.length == 0 || libraryData?.isVideo) &&
                            <>
                                <div style={{flexGrow: '1'}}></div>
                                {
                                    selectTag &&
                                    <div className={'flex-row-vertical-center mr-12'} style={{background:'var(--draw-tool-bar-selected-color)',borderRadius:'100px',height:'32px',padding:'0 10px',}}>
                                        <span>{selectTag.label}</span>
                                        <img className={'img-14 cursor-pointer'} src={getImagePathWithTheme('tag_close')} onClick={()=>{
                                            setSelectTag(null);
                                            projectTagFilterRef.current?.onResetTag();
                                        }}/>
                                    </div>
                                }

                                {
                                    selectSliderRightMenu == 'project' &&
                                    <img id={'img-home-search-1'} className={'img-16 cursor-pointer mr-16'} style={{marginTop: '0px',padding:'1px'}} onClick={async ()=>{
                                        //转到首页..
                                        let home = await getNoteById(KEY_DEFAULT_PROJECT_ID);
                                        if (!home){
                                            home = createEmptyProject(KEY_DEFAULT_PROJECT_ID,t("Home"));
                                        }
                                        setSliderProjectData(home)
                                    }} src={getImagePathWithTheme('slider_home_project_home.svg')}/>
                                }
                                {/*//设计图标偏差，视觉偏差*/}

                                {
                                    !libraryData?.isVideo &&
                                    <img className={'img-16 cursor-pointer mr-8'}
                                         style={{marginTop: libraryData?.isVideo ? '0px' : '3px'}} onClick={() => {
                                        setIsSearch(!isSearch);
                                        if (libraryData?.isVideo) {
                                            setSearchPlaceholder(t("Search highlights"));
                                        } else {
                                            if (selectSliderRightMenu == 'library') {
                                                setSearchPlaceholder(t("Search library"));
                                            } else if (selectSliderRightMenu == 'highlight') {
                                                setSearchPlaceholder(t("Search highlights"));
                                            } else if (selectSliderRightMenu == 'project') {
                                                setSearchPlaceholder(t("Search projects"))
                                            }
                                        }
                                        setTimeout(() => {
                                            document.getElementById('input-main-library-search')?.focus();
                                        }, 100);
                                    }} src={getImagePathWithTheme('search_black.svg')}/>
                                }


                                {
                                    selectSliderRightMenu == 'project' &&
                                    <>
                                        <ProjectTagFilter ref={projectTagFilterRef} margin={'4px 0 0 2px'}
                                                          onRefreshData={(szTagName: any) => {
                                                              sideProjectRef.current?.updateNoteList(szTagName);
                                                          }} onTagSelected={(tag: any) => {
                                            setSelectTag(tag);
                                        }}/>
                                        <ProjectSort margin={'4px 0 0 4px'} onRefreshData={() => {
                                            sideProjectRef.current?.updateNoteList();
                                        }}/>
                                    </>
                                }
                            </>
                        }


                        {
                            !global.g_isPresentMode && arrayBreadcrumb.length > 0 &&
                            <Dropdown trigger={["click"]}
                                      menu={{items: getSliderMoreItems(), onClick: onSliderClickMenu}}>
                            <img style={{flexShrink: '0',marginRight:'2px',marginTop:libraryData?.isVideo?'1px':'0px',opacity:isDarkMode()?'0.55':'1'}} className={'img-14 cursor-pointer'}
                                     src={getImagePathWithTheme('vertical_more')}/>
                            </Dropdown>
                        }
                    </div>
                }


                {
                    selectSliderRightMenu != 'info' && ((libraryData && (libraryData.type == 'card' || libraryData.type == 'journal'))) && rightSliderWidth > 0 &&
                    <div ref={divSliderContainerRef} id='div-main-edit-container' className={'editor-container------'}
                         style={{overflowY: 'auto', height: '100%', margin: '0px -12px', padding: '0 30px',display:'flex',borderTop:sideBarStatus == 2?'1px solid var(--line-color)':'none'}}>
                        <div style={{
                            position: 'relative', /*minWidth: `${headerTreeWidth}px`,*/
                            overflow: 'hidden',
                            width: '220px',
                            flexShrink: '0',
                            marginLeft: '-24px',
                            display: sideBarStatus == 2 ? 'inherit' : 'none'
                        }}>
                            {
                                editor &&
                                <SideBarFold ref={sideBarFoldRef} editor={editor} from={FROM_RIGHT_SIDE}
                                             data={libraryData} onCollapseCallback={(sidebarStatus: boolean) => {
                                                 setSideBarStatus(sidebarStatus)
                                }}/>
                            }
                        </div>

                        <div style={{
                            background: 'var(--draw-slider-card-background-color)',
                            height: '100%',
                            border: '1px solid var(--draw-slider-card-border-color)',
                            // borderRadius: '8px',
                            // margin: '0 -8px',
                            padding: '0 8px',
                            overflowY: 'auto',
                            borderTop:sideBarStatus == 2?'none':'1px solid var(--draw-slider-card-border-color)',
                            width:'100%'
                        }}>
                            <Editor ref={editorRef} data={libraryData} from={FROM_LIBRARY} source={'rightSlider'}
                                    onUpdate={(data) => {
                                        postMessage(EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER, {data: data});
                                        //更新..
                                        // updateCard(data);
                                    }} onInitComplete={(editor)=>{
                                        mEditorRef.current = editor;
                                        setEditor(editor);
                            }}/>
                        </div>
                    </div>
                }

                {//pdf部分
                    libraryData && libraryData.type == 'pdf' && rightSliderWidth > 0 &&
                    <iframe
                        ref={iframeRef}
                        key={libraryData?.id}
                        id={"pdf-main-iframe-slider"}
                        src={(APP_WEB ? "/" : "") + "pdf/reader.html?type=pdf"}
                        style={{
                            border: 'none',
                            width: "100%",
                            height: "100vh",
                            pointerEvents: iframePdfContainerPointerEvent
                        }}
                    />
                }

                {
                    //视频这里是不同的container
                    libraryData && (libraryData.isVideo) && rightSliderWidth > 0 &&
                    <div style={{padding:'0 16px',overflow:'hidden',height:'100%',background:isDarkMode()?'transparent':'white',paddingBottom:'16px'}}/*className={clsx("excalidraw excalidraw-container", {})}*/>
                        {(isFileVideoElement(libraryData.videoNotes.element) || isAudioFileElement(libraryData.videoNotes.element)) && (
                            <VideoLocalContent videoNotes={libraryData.videoNotes} from={'slider'} subFrom={FROM_LIBRARY} ref={videoContentRef} />
                        )}
                        {isEmbeddableElement(libraryData.videoNotes.element) && (
                            <VideoContent videoNotes={libraryData.videoNotes} from={'slider'} subFrom={FROM_LIBRARY} pointerEvents={libraryContainerPointerEvent}  ref={videoContentRef} />
                        )}
                    </div>
                }

                {
                    //project
                    sliderProjectData &&
                    <>
                        <div className={'flex-row-vertical-center'}
                             style={{height: '45px', padding: '0 16px', minHeight: '45px',borderBottom:'1px solid var(--right-slider-project-split-color)'}}>
                            {/*<Popover arrow={false} align={{offset: [46, 6]}} placement={"bottom"} trigger={['click']}*/}
                            {/*         open={isShowPopupBoard} onOpenChange={(e) => setIsShowPopupBoard(e)}*/}
                            {/*         overlayInnerStyle={{padding: '0', margin: '0'}}*/}
                            {/*         content={renderSliderProjectBoard()}>*/}
                            {/*    <img className='img-32 hovered-gray-radius ml-0'*/}
                            {/*         src={getImagePathWithTheme('left_slider_2')}/>*/}
                            {/*</Popover>*/}
                            <img className='img-32 hovered-gray-radius ml-0'
                                 src={getImagePathWithTheme('left_slider_2.svg')} onClick={()=>{
                                sendMessageFromDraw('toggleLeftMenu');
                            }}/>

                            <span className={'ml-6'}>{sliderProjectData?.name}</span>

                            <div className={'flex-center'} style={{marginLeft: 'auto'}}>
                                {/*//交互侧栏和主画布*/}
                                {/*//侧栏画布全屏*/}
                                <img className='img-16 ml-16 cursor-pointer'
                                     onClick={() => {
                                         window.setLeftSelect('');
                                         drawIndexSliderHeaderAction("collapse");
                                         window.navigateOrigin(getDrawPath(), {
                                             state: {
                                                 noteData: sliderProjectData,
                                                 searchKey: ''
                                             }
                                         });
                                     }} src={getImagePathWithTheme('draw_fullscreen')}/>
                            </div>
                        </div>
                        <iframe id={'iframe-slider-global-drawindex-container'} style={{
                            display: sliderProjectData ? 'inherit' : 'none',
                            width: '100%',
                            height: '100%',
                            minHeight: 'calc(100% - 92px)',
                            border: 'none',
                            pointerEvents: iframePdfContainerPointerEvent
                        }}
                                src={getProjectSrc()}
                        />
                    </>
                }

                {
                    selectSliderRightMenu != 'info' && !libraryData &&
                    <>
                    {
                        selectSliderRightMenu == 'library' && !libraryData &&
                        <div style={{marginTop: '0px', height: isMac() ? 'calc(100% - 70px)' : 'calc(100% - 100px)'}}>
                            {
                                <div style={{
                                    marginTop: '-4px',
                                    height: '100%',
                                    pointerEvents: iframePdfContainerPointerEvent
                                }}>
                                    <PageLibrary ref={pageLibraryRef} from={FROM_LIBRARY} subFromPage={FROM_LIBRARY}
                                                 isInsertNewLibrary={true}
                                                 type={''}
                                                 pointerEvent={libraryContainerPointerEvent}/>
                                </div>
                            }
                        </div>
                    }

                        {
                            selectSliderRightMenu == 'journal' && !libraryData && rightSliderWidth >0 && //为什么要 rightSliderWidth >0 因为这里在画布页会被加载...
                            <div style={{
                                marginTop: '0px',
                                height: isMac() ? 'calc(100% - 42px)' : 'calc(100% - 42px)'
                            }}>
                                {
                                    <PageJournal from={FROM_LIBRARY} journalData={journalData} onUpdate={(data: any) => {
                                        //退到这里来发消息.
                                        postMessage(EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER, {data: data});
                                    }}/>
                                }
                            </div>
                        }

                        {
                            selectSliderRightMenu == 'highlight' && !libraryData &&
                            <div style={{
                                marginTop: '0px',
                                height: isMac() ? 'calc(100% - 70px)' : 'calc(100% - 100px)'
                            }}>

                                {
                                    <div
                                        style={{
                                            marginTop: '-4px',
                                            height: '100%',
                                            pointerEvents: iframePdfContainerPointerEvent
                                        }}>
                                        <PageHighlight ref={pageHighlightRef} from={FROM_LIBRARY}/>
                                    </div>
                                }
                            </div>
                        }

                        {
                            selectSliderRightMenu == 'project' && !sliderProjectData &&
                            <div style={{
                                marginTop: '0px',
                                height: isMac() ? 'calc(100% - 70px)' : 'calc(100% - 100px)'
                            }}>
                                {
                                    <div>
                                        <HomeIndex ref={sideProjectRef} from={FROM_RIGHT_SIDE}
                                                   onCallback={async (szAction: any, data: any) => {
                                                       if (szAction == 'nagivator') {
                                                           const doc = await getNoteJsonDoc(data.id);
                                                           setSliderProjectData({...data, doc});
                                                           // setSliderHeaderVisible(false);
                                                       }
                                                   }}/>
                                    </div>
                                }
                            </div>
                        }
                    </>
                }

                {
                    selectSliderRightMenu == 'info' &&
                    <div style={{padding: '0 20px', height: '100%'}}>
                        {
                            sliderTitleInfo &&
                            <div className={'flex-row-vertical-center'} style={{height: '56px'}}>
                                <img className={'img-16'}
                                     src={getImagePathWithTheme(sliderTitleInfo?.image)}/>
                                <span className={'ml-6'}>{sliderTitleInfo?.title}</span>
                            </div>
                        }
                        {
                            !sliderTitleInfo &&
                            <span style={{
                                color: 'var(--text-color-bab8b8)',
                                marginTop: '22px',
                                display: 'block'
                            }}>{t("NoInformation")}</span>
                        }

                        <div style={{
                            opacity: sliderTitleInfo ? '1' : '0',
                            marginTop: '0px',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            border: '1px solid var(--line-color)',
                            padding: '16px',
                            background: 'var(--background-color-white)',
                            height: '100%',
                            overflowX:'hidden'
                        }}>
                            <div style={{marginTop: '-12px',}}>
                                <LibraryInfos from={FROM_RIGHT_SIDEBAR} ref={sideInfoRef} from={'RightSlider'} height={0}/>
                            </div>
                        </div>
                    </div>
                }

                {
                    selectSliderRightMenu == 'webview' && !libraryData &&
                    <CustomWebView pointerEvents={iframePdfContainerPointerEvent} selectType={selectSliderRightMenu}/>
                }

            </div>
        </div>
    )
})

export default RightSlider;